export default function useSilentUri(unsubscribeSilentUriLength) {
    return unsubscribeSilentUriLength > 0;
}
//# sourceMappingURL=useSilentUri.js.map